import { useOverviewTabData } from "@/hooks";
import parseEncodedJSON from "@/lib/parseEncodedJSON";
import { hooks } from "@/styles/breakpoints";
import parse from "html-react-parser";
import Spinner from "../Spinner";
import FundObjective from "./FundObjective";
import * as objectiveStyles from "./FundObjective.css";
import * as styles from "./FundOverview.css";
import FundRatings from "./FundRatings";
import KeyInfo from "./KeyInfo";
import Managers from "./Managers";
import { FundObjectiveConfigSchema, type Props } from "./types";

const { useIsBelow } = hooks;

export default function FundOverview({
	config,
	fundId,
	managers,
	citywireImages,
}: Props) {
	const isBelowL = useIsBelow("l");
	const { data, isLoading, shareClasses } = useOverviewTabData(config, fundId);
	if (!data || isLoading) {
		return <Spinner />;
	}

	const objectiveTitle =
		"config" in data.objective
			? FundObjectiveConfigSchema.safeParse(
					parseEncodedJSON(data.objective.config),
				)
			: { success: false, data: { title: undefined } };

	return (
		<div className={styles.layout()}>
			<div className={styles.slot({ name: "objective" })}>
				{data.sdrNote && "text" in data.sdrNote && (
					<div className={objectiveStyles.objectiveText()}>
						{parse(data.sdrNote.text)}
					</div>
				)}
				{"text" in data.objective && (
					<FundObjective
						title={
							objectiveTitle.success ? objectiveTitle.data.title : undefined
						}
						text={data.objective.text}
					/>
				)}
				{!isBelowL && <FundRatings ratings={data.ratings} />}
			</div>
			<div className={styles.slot({ name: "keyinfo" })}>
				<KeyInfo
					tables={data.keyinfo.tables}
					sectors={data.keyinfo.sectors}
					yields={data.keyinfo.yields}
					primaryShareClass={shareClasses.at(0)}
					asAtDate={data.asAtDate?.formattedDate}
				/>
			</div>
			<div className={styles.slot({ name: "managers" })}>
				{managers && (
					<Managers managers={managers} citywireRatings={citywireImages} />
				)}
				{isBelowL && <FundRatings ratings={data.ratings} />}
				{!isBelowL && (
					<div className={styles.asAtDate}>{data.asAtDate?.formattedDate}</div>
				)}
			</div>
		</div>
	);
}
